import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function() {
    initHeaderReveal(); 
    initHeroReveal(); 
    initHeroAnimation();
    initTitleFromBottom();
    initElementFromBottom();
    initElementAppear();
    initLogosHoverAnimation();
    initUnveilFromTop();
    initDirectionsSection();
    initSlider();
    initAnimatingTextPanel();
    initFloatingGradient();
});

const duration = 1.5;
let heroRevealTl;

const initHeaderReveal = () => {
    const navbar = document.querySelector('.navbar');
    const navBrand = document.querySelector('.navbar-brand');
    if (!navbar) return;

    const tl = gsap.timeline();

    tl.fromTo(navbar, 
        { 
            y: -130,          
        }, 
        { 
            y: 0,             
            duration: 0.7, 
            ease: "cubic-bezier" 
        }
    );

    tl.fromTo(navBrand, 
        { 
            opacity: 0,
        }, 
        { 
            opacity: 1, 
            duration: 0.8, 
            ease: "cubic-bezier" 
        },
        "-=0.2"               
    );

    if (navBrand) {
        navBrand.addEventListener("mouseenter", () => {
            gsap.to(navBrand, { opacity: 0.3, duration: 0.3, ease: "cubic-bezier" });
        });
        
        navBrand.addEventListener("mouseleave", () => {
            gsap.to(navBrand, { opacity: 1, duration: 0.3, ease: "cubic-bezier" });
        });
    }
};

const initHeroReveal = () => {
    const hero = document.querySelector(".bw-hero");
    if (!hero) return;

    const isMobile = window.innerWidth < 900;

    const tl = gsap.timeline();

    tl.fromTo(".hero-moving-image", 
        { 
            y: -150,  
            opacity: 0,        
        }, 
        { 
            y: 0,             
            duration: 1.3, 
            opacity: 1,
            ease: "cubic-bezier" 
        },
        0
    );

    tl.fromTo(".hero-text-row", 
        {
            opacity: 0,
            y: -50,
        },
        { 
            y: 0,
            opacity: 1,
            duration: 1,
            autoAlpha: 1,
            ease: "cubic-bezier"
        }, 
        "-=0.4" 
    );

    tl.fromTo(".hero-title", 
        { 
            opacity: 0,
            y: 300      
        }, 
        {
            y: 0,
            duration: 1.3,
            autoAlpha: 1,
            ease: "cubic-bezier"
        },
        0 
    );
    return tl;
};

const initHeroAnimation = () => {
    const hero = document.querySelector(".bw-hero");
    if (!hero) return;

    const isMobile = window.innerWidth < 900;

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: hero,
            start: "top top",
            end: "+=100%",
            scrub: 1,
            pin: false,
            invalidateOnRefresh: true,
        }
    });

    tl.set([".hero-moving-image", ".hero-text-row", ".hero-title"], {
        y: 0,
        opacity: 1,
        scale: 1,
        autoAlpha: 1,
        overwrite: "auto" 
    }, 0);

    tl.to(".hero-moving-image", {
        y: "-25vh",
        autoAlpha: 0,
        duration: 0.4,
        ease: "none"
    }, 0);

    tl.to(".hero-text-row", {
        y: isMobile ? "-25vh" : 0,
        scale: 0.6,
        autoAlpha: 0,
        duration: 0.4,
        ease: "none"
    }, 0);

    tl.to(".hero-title", {
        y: "40vh",
        scale: 0.8,
        duration: 1,
        ease: "none"
    }, 0);
};

const initTitleFromBottom = () => {
    
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".from-bottom-line-1", 
            start: "top 90%",
            once: true
        }
    });

    tl.fromTo(".from-bottom-line-1", 
        { 
            opacity: 0, 
            y: 80, 
        }, 
        { 
            opacity: 1, 
            y: 0, 
            duration: 1.2, 
            ease: "cubic-bezier" 
        }
    );

    tl.fromTo(".from-bottom-line-2", 
        { 
            opacity: 0, 
            y: 60, 
        }, 
        { 
            opacity: 1, 
            y: 0, 
            duration: 1.2, 
            ease: "cubic-bezier" 
        },
        "-=1.2" 
    );
};

const initElementFromBottom = () => {
    const targets = document.querySelectorAll('.element-from-bottom');
    
    targets.forEach((target) => {
        gsap.fromTo(target, 
            { 
                opacity: 0, 
                y: 100,
            }, 
            { 
                opacity: 1, 
                y: 0, 
                duration: 2.5, 
                ease: "power4.out",
                scrollTrigger: {
                    trigger: target, 
                    start: "top 85%", 
                    once: true,
                    invalidateOnRefresh: true
                }
            }
        );
    });
};

const initElementAppear = () => {
    const targets = document.querySelectorAll('.appear-element');
    
    targets.forEach((target) => {
        gsap.fromTo(target, 
            { opacity: 0 }, 
            { 
                opacity: 1, 
                duration: 1.5, 
                ease: "cubic-bezier", 
                scrollTrigger: {
                    trigger: target, 
                    start: "top 85%",
                    once: true,
                }
            }
        );
    });
};

const initLogosHoverAnimation = () => {
    const logoColumns = document.querySelectorAll('.logos-row > div');

    logoColumns.forEach((currentCol) => {
        const img = currentCol.querySelector('.logo-image');
        const desc = currentCol.querySelector('.logo-description');

        currentCol.addEventListener('mouseenter', () => {
            gsap.to([img, desc], {
                scale: 1.15,
                y: 0, 
                duration: 0.6,
                ease: "power2.out",
                overwrite: "auto"
            });

            logoColumns.forEach((otherCol) => {
                if (otherCol !== currentCol) {
                    const otherImg = otherCol.querySelector('.logo-image');
                    const otherDesc = otherCol.querySelector('.logo-description');
                    
                    gsap.to([otherImg, otherDesc], {
                        y: 20,       
                        duration: 0.6,
                        ease: "power2.out",
                        overwrite: "auto"
                    });
                }
            });
        });

        currentCol.addEventListener('mouseleave', () => {
            logoColumns.forEach((col) => {
                const colImg = col.querySelector('.logo-image');
                const colDesc = col.querySelector('.logo-description');

                gsap.to([colImg, colDesc], {
                    y: 0,
                    duration: 0.6,
                    ease: "power2.out",
                    overwrite: "auto"
                });
            });
        });
    });
};

const initDirectionsSection = () => {
    if (window.innerWidth <= 768) return;

    const section = document.querySelector('.directions-section');
    const list = document.querySelector('.directions-list');
    const title = document.querySelector('.directions-title');
    const content = document.querySelector('.directions-content');
    const leftBg = document.querySelector('.left-background');
    const rightBg = document.querySelector('.right-background');
    const slidingImage = document.querySelector('.sliding-image');

    if (!section || !leftBg || !rightBg) return;

    const leftItems = section.querySelectorAll('.direction-item:nth-child(odd)');
    const rightItems = section.querySelectorAll('.direction-item:nth-child(even)');

    let currentArea = null; 
    let leftY = 0;
    let rightY = 0;

    section.addEventListener('wheel', (e) => {
        if (!currentArea) return;

        const sectionTop = section.getBoundingClientRect().top;
        if (sectionTop > 50) return;

        const speed = 1; 
        const maxDistance = content.offsetHeight - title.offsetHeight - list.offsetHeight;
        
        if (currentArea === 'left') {
            leftY += e.deltaY * speed;
            leftY = Math.max(0, Math.min(leftY, maxDistance));

            gsap.to(leftItems, { y: leftY - 50, duration: 0.2, ease: "power1.out", overwrite: "auto" });
        } else if (currentArea === 'right') {
            rightY += e.deltaY * speed;
            rightY = Math.max(0, Math.min(rightY, maxDistance));

            gsap.to(rightItems, { y: rightY - 50, duration: 0.2, ease: "power1.out", overwrite: "auto" });
        }
    });

    section.addEventListener('mousemove', (e) => {
        const { clientX } = e;
        const { left, width } = section.getBoundingClientRect();
        
        const relativeX = (clientX - left) / width;
        const targetArea = (relativeX < 0.5) ? 'left' : 'right';

        if (targetArea !== currentArea) {
            currentArea = targetArea;

            if (currentArea === 'left') {
                gsap.to(leftItems, { y: leftY - 50, duration: 0.4, ease: "power2.out", overwrite: "auto" });
                rightY = 0;
                gsap.to(rightItems, { y: 0, duration: 0.4, ease: "power2.out", overwrite: "auto" });
                
                if (slidingImage) {
                    gsap.to(slidingImage, { x: "-250px", rotate: -55, duration: 0.6, ease: "power2.out", overwrite: "auto" });
                }
                
                leftBg.classList.add('active');
                rightBg.classList.remove('active');
            } else {
                gsap.to(rightItems, { y: rightY - 50, duration: 0.4, ease: "power2.out", overwrite: "auto" });
                leftY = 0;
                gsap.to(leftItems, { y: 0, duration: 0.4, ease: "power2.out", overwrite: "auto" });
                
                if (slidingImage) {
                    gsap.to(slidingImage, { x: "250px", rotate: 55, duration: 0.6, ease: "power2.out", overwrite: "auto" });
                }
                
                rightBg.classList.add('active');
                leftBg.classList.remove('active');
            }
        }
    });

    section.addEventListener('mouseleave', () => {
        currentArea = null;
        leftY = 0;
        rightY = 0;
        
        gsap.to([leftItems, rightItems], { y: 0, duration: 0.4, ease: "power2.out", overwrite: "auto" });

        if (slidingImage) {
            gsap.to(slidingImage, { x: 0, rotate: 0, duration: 0.6, ease: "power2.out", overwrite: "auto" });
        }
        
        leftBg.classList.add('active');
        rightBg.classList.remove('active');
    });
};

const initUnveilFromTop = () => {
    
    const containers = document.querySelectorAll('.unveil-from-top-container');

    containers.forEach((container) => {
        
        const target = container.querySelector('.unveil-from-top');

        if (target) {
            gsap.to(target, {
                clipPath: 'inset(0% 0% 0% 0%)', 
                ease: "power4.inOut",
                duration: 2,
                scrollTrigger: {
                    trigger: container, 
                    start: "top 85%",    
                    toggleActions: "play none none none", 
                    invalidateOnRefresh: true,
                }
            });
        }
    });
}

const initSlider = () => {
    const wrapper = document.getElementById("slider-wrapper");
    const section = document.getElementById("slider");

    if (wrapper && section) {
        const scrollDuration = wrapper.scrollWidth / 2.5;
        const extraPause = 800; 

        ScrollTrigger.create({
            trigger: "#slider",
            start: "top top",
            end: () => "+=" + (scrollDuration + extraPause),
            pin: true,
            scrub: 1,
            invalidateOnRefresh: true,
        });

        gsap.to("#slider-wrapper", {
            x: () => -(wrapper.scrollWidth - window.innerWidth),
            ease: "none",
            scrollTrigger: {
                trigger: "#slider",
                start: "top top",
                end: () => "+=" + scrollDuration,
                scrub: 1,
                invalidateOnRefresh: true, 
            }
        });
    }
}

const initAnimatingTextPanel = () => {
    const container = document.querySelector('.animating-logo');
    if (!container) return;

    const section = document.querySelector('.animating-text-panel');
    if (!section) return;

    const first = container.querySelector('.animating-first');
    const second = container.querySelector('.animating-second');
    const third = container.querySelector('.animating-third');
    const fourth = container.querySelector('.animating-fourth');
    const donut = container.querySelector('.donut-element');
    const sixth = container.querySelector('.animating-sixth');

    const isMobile = window.innerWidth < 768;

    // Rimuoviamo il vecchio gsap.set dello scale. Forziamo solo il rendering 2D/3D pulito
    gsap.set(donut, { force3D: true });

    const tl = gsap.timeline({
        defaults: {
            ease: "none"
        },
        scrollTrigger: {
            trigger: section,
            start: "top top",
            end: isMobile ? "+=1000" : "+=1500",
            pin: true,
            scrub: 0.4,
            anticipatePin: 1
        }
    });

    // STEP 1
    tl.to(donut, {
        width: 50.4,
        height: 50.4,
        borderWidth: 12.6,
        x: 0,
        top: 16
    }, "+=0.2");

    // STEP 2
    tl.to(donut, {
        width: 108,
        height: 108,
        borderWidth: 27,
        //x: -20,
        top: -12
    })
    .to(container, {
        paddingBottom: 32
    }, "<")
    .to([fourth, sixth], {
        autoAlpha: 0,
        duration: 0.3
    }, "<");

    // STEP 3
    tl.to(donut, {
        width: 180,
        height: 180,
        borderWidth: 45,
        //x: -35
        top: -54
    })
    .to(container, {
        paddingBottom: 62
    }, "<")
    .to(third, {
        autoAlpha: 0
    }, "<");

    // STEP 4
    tl.to(donut, {
        width: 216,
        height: 216,
        borderWidth: 54,
        //x: -50
        top: -76,
        right: 12
    })
    .to(container, {
        paddingBottom: 86
    }, "<")
    .to(second, {
        autoAlpha: 0
    }, "<");

    // STEP 5 - Arrivo alla dimensione massima (252px) e coordinate finali
    tl.to(donut, {
        width: 252,
        height: 252,
        borderWidth: 63,
        //top: 108,     
        top: -96,
        right: -8
    })
    .to(container, {
        paddingBottom: 106
    }, "<")
    .to(first, {
        autoAlpha: 0
    }, "<");

    return tl;
};

const initFloatingGradient = () => {
    const gradient = document.querySelector('.floating-gradient');
    if (!gradient) return;

    gsap.set(gradient, { 
        yPercent: 100 
    });

    gsap.to(gradient, {
        yPercent: 0,       
        y: -10,            
        duration: 4,       
        ease: "power1.out", 
        force3D: true      
    });
};


